import Api from "app/services/common/Api";
import { ApiUrlUtil } from "app/utils/apiUrlUtil";
import axios from "axios";
import { HeadersUtil } from "app/utils/headersUtil";
import {
  UsageLoadSearchModel,
  WorkDemandPowerSearchModel,
  WorkSearchModel,
} from "app/model/work/workElectricModel";
import {
  PwrUsageDayModel,
  PwrUsageMonthModel,
  PwrUsageSearchModel,
  PwrUsageTimeModel, SupplyConsumeStatistics, UsageLoadLatest,
} from "app/model/mg/pwrModel";
import {ChargeModel} from "app/model/mg/ChargeModel";
import { CoSearchModel } from "app/model/common/coModel";
import {
  Facility,
  FacilityControl,
  FacilityControlSave,
  FacilitySearch
} from "app/model/mg/FacilityModel";
import { FacilityHistory } from "app/model/mg/FacilityHistoryModel";
import { PvMaintPvEffModel } from "app/model/pvmaint/pvMaintPvEffModel";
import {PvMaintPvStatModel} from "../../model/pvmaint/pvMaintPvStatModel";
import {PvMaintPvStatSummaryModel} from "../../model/pvmaint/pvMaintPvStatSummaryModel";
import {PvMainReportDataModel} from "../../model/pvmaint/pvMainReportDataModel";

export interface Mdb021ChartSearchModel {
  searchType: string;
  fromDt: string;
  toDt: string;
}
export class PcUserService extends Api {
  private static service: PcUserService;

  public static getInstance(): PcUserService {
    if (!PcUserService.service) {
      PcUserService.service = new PcUserService();
    }
    return PcUserService.service;
  }

  // 사용자 - 생산/소비 현황
  // 설비현황
  public async getUserInverterHeaderData() {
    const url = ApiUrlUtil.buildQueryString(process.env.REACT_APP_URL_CO + "/pc/facility/status/pv/statistics");
    return await super.get<any>(url);
  }

  public async getUserInverterEfficiency(page: number) {
    const url = ApiUrlUtil.buildQueryString(process.env.REACT_APP_URL_CO + `/pc/facility/status/pv?page=${page}&perPage=5`);
    return await axios.get(url, {headers: HeadersUtil.getHeaders(),});
  }

  public getUserEssEfficiency(page: number) {
    const url = ApiUrlUtil.buildQueryString(process.env.REACT_APP_URL_CO +
      "/pc/facility/status/ess?page=" +
      page +
      "&perPage=4"
    );
    return axios.get(url, {headers: HeadersUtil.getHeaders(),});
  }

  public getUserEqEfficiency(page: number) {
    const url = ApiUrlUtil.buildQueryString(process.env.REACT_APP_URL_CO +
      "/pc/facility/status/fcl?page=" +
      page +
      "&perPage=4"
    );
    return axios.get(url, {headers: HeadersUtil.getHeaders(),});
  }

  // 부하별 사용량
  public getUserLoadResourceList() {
    const url = ApiUrlUtil.buildQueryString(process.env.REACT_APP_URL_CO + "/user/facilities?emksRsrcClCd=23");
    return super.get<any>(url);
  }

  public async getUserLoadChartByTime(param: UsageLoadSearchModel) {
    const url = ApiUrlUtil.buildQueryString(process.env.REACT_APP_URL_CO + "/pc/eu/usageload/hour");
    return super.get<any>(url, param);
  }

  // 발전량 예측 - 차트
  public async getPowerGenChart() {
    const url: string = process.env.REACT_APP_URL_CO + "/pc/forecast/power";
    return super.get<any[]>(url);
  }

  // 부하량 예측
  public async getLoadChart() {
    const url: string = process.env.REACT_APP_URL_CO + "/pc/forecast/load";
    return super.get<any[]>(url);
  }

  // 최대수요전력
  public getKepcoCustomerData() {
    const url = ApiUrlUtil.buildQueryString(process.env.REACT_APP_URL_CO + "/user/customers");
    return super.get<any>(url);
  }

  public getDemandPower(search: WorkDemandPowerSearchModel) {
    const url = ApiUrlUtil.buildQueryString(process.env.REACT_APP_URL_CO + "/pc/eu/demandpower/info");
    return super.get<any>(url, search);
  }

  public async getDemandPowerChart(search: WorkDemandPowerSearchModel) {
    const url = process.env.REACT_APP_URL_CO + "/pc/eu/demandpower/usage";
    return super.get<any>(url, search);
  }

  // ESS 현황
  public getEssStatusHeader() {
    const url = ApiUrlUtil.buildQueryString(process.env.REACT_APP_URL_CO + "/pc/renewal/ess/statistics");
    return super.get<any>(url);
  }

  public async getEssStatusChart(param: WorkSearchModel) {
    const url = ApiUrlUtil.buildQueryString(process.env.REACT_APP_URL_CO + "/pc/renewal/ess");
    return await super.get<any>(url, param);
  }

  // 태양광발전
  public getSolarStatistics() {
    const url = ApiUrlUtil.buildQueryString(process.env.REACT_APP_URL_CO + "/pc/renewal/solar/statistics");
    return super.get<any>(url);
  }

  public async getSolarData(param: WorkSearchModel) {
    const url = ApiUrlUtil.buildQueryString(process.env.REACT_APP_URL_CO + "/pc/renewal/solar");
    return await super.get<any>(url, param);
  }

  // 시간대별 사용량 조회
  public async getTimeUsageByLoad(fromDt: string) {
    const url = ApiUrlUtil.buildQueryString(process.env.REACT_APP_URL_CO +
      "/pc/eu/timeusege/user/pwr/use/tmz?fromDt=" +
      fromDt
    );
    return await super.get<any>(url);
  }

  public async getDayUsageByLoad(fromDt: string) {
    const url = ApiUrlUtil.buildQueryString(process.env.REACT_APP_URL_CO +
      "/pc/eu/dayusege/user/pwr/use/tmz?fromDt=" +
      fromDt
    );
    return await super.get<any>(url);
  }

  public async getMonthUsageByLoad(fromDt: string) {
    const url = ApiUrlUtil.buildQueryString(process.env.REACT_APP_URL_CO +
      "/pc/eu/monthusege/user/pwr/use/tmz?fromDt=" +
      fromDt
    );
    return await super.get<any>(url);
  }

  public async getTimeUsage(fromDt: string) {
    const url = ApiUrlUtil.buildQueryString(process.env.REACT_APP_URL_CO +
      "/pc/eu/timeusege/user/pwr/use/trend?fromDt=" +
      fromDt
    );
    return await super.get<PwrUsageTimeModel[]>(url);
  }

  public async getDayUsage(fromDt: string) {
    const url = ApiUrlUtil.buildQueryString(process.env.REACT_APP_URL_CO +
      "/pc/eu/dayusege/user/pwr/use/trend?fromDt=" +
      fromDt
    );
    return await super.get<PwrUsageDayModel[]>(url);
  }

  public async getMonthUsage(fromDt: string) {
    const url = ApiUrlUtil.buildQueryString(process.env.REACT_APP_URL_CO +
      "/pc/eu/monthusege/user/pwr/use/trend?fromDt=" +
      fromDt
    );
    return await super.get<PwrUsageMonthModel[]>(url);
  }

  public async getHeaderDataSuConSum() {
    const url = ApiUrlUtil.buildQueryString(process.env.REACT_APP_URL_CO + "/pc/eu/supplyconsumption/statistics");
    return super.get<SupplyConsumeStatistics>(url);
  }

  public async getChartDataSuConSum(search: PwrUsageSearchModel) {
    const url = ApiUrlUtil.buildQueryString(process.env.REACT_APP_URL_CO +
      "/pc/eu/supplyconsumption",
      search
    );
    return await axios.get(url, {headers: HeadersUtil.getHeaders(),});
  }

  public async getHeaderDataInPowUsa(param: CoSearchModel) {
    const url = ApiUrlUtil.buildQueryString(process.env.REACT_APP_URL_CO + "/pc/eu/invalidpowrusage/statistics");
    return await super.get<any>(url, param);
  }

  public getChartDataInPowUsa(param: CoSearchModel) {
    const url = ApiUrlUtil.buildQueryString(process.env.REACT_APP_URL_CO + "/pc/eu/invalidpowrusage");
    return super.get<any>(url, param);
  }

  public getHeaderDataDischaStatus() {
    const url = ApiUrlUtil.buildQueryString(process.env.REACT_APP_URL_CO + "/pc/gas/dischargstatus/statistics");
    return super.get<any>(url);
  }

  public getChartDataDisChaStatus(param: WorkSearchModel) {
    const url = ApiUrlUtil.buildQueryString(process.env.REACT_APP_URL_CO + "/pc/gas/dischargstatus");
    return super.get<any>(url, param);
  }

  public getHeaderDataFareCheck() {
    const url = ApiUrlUtil.buildQueryString(process.env.REACT_APP_URL_CO + "/pc/charges/farecheck/statistics");
    return super.get<any>(url);
  }

  public getChartDataFareCheck(param: Mdb021ChartSearchModel) {
    const url = ApiUrlUtil.buildQueryString(process.env.REACT_APP_URL_CO +
      "/pc/charges/farecheck",
      param
    );
    return axios.get(url, {headers: HeadersUtil.getHeaders(),});
  }

  // 추천요금제
  public async getRecommendPlan(kepcoCustNo: string, fromDt:string) {
    const param = {
      searchKepcoCustNo: kepcoCustNo,
      fromDt: fromDt,
    };
    const url = process.env.REACT_APP_URL_CO + "/pc/charges/pricingplan";
    return await super.get<ChargeModel>(url, param);
  }

  // 설비 제어 목록
  public async getFacilities(param: FacilitySearch) {
    const url = process.env.REACT_APP_URL_CO + '/mg/facility';
    return await super.get<Facility[]>(url, param);
  }

  // 설비 제어 - 제어한 설비의 최근 상태값
  public async getRecentPointValues(param: FacilitySearch) {
    const url = process.env.REACT_APP_URL_CO + '/mg/facility/recent';
    return await super.get<FacilityControl[]>(url, param);
  }

  // 설비 제어 - 변경된 제어 상태값 저장
  public async saveControlPointValues(param: FacilityControlSave[]) {
    const url = process.env.REACT_APP_URL_CO + '/mg/facility/his';
    return await super.post<boolean>(url, param);
  }

  public async getFacilityHistories(param: FacilitySearch) {
    const url = process.env.REACT_APP_URL_CO + '/mg/facility/his';
    return await super.get<FacilityHistory[]>(url, param);
  }

  // 부하별사용량조회 - 해당날짜의 최신데이터 조회
  public getUsageloadLatest (fromDt : string) {
    const url = process.env.REACT_APP_URL_CO + "/pc/eu/usageload/latest";
    return super.get<UsageLoadLatest[]>(url, {fromDt});
  }

  // 부하별사용량조회 - 상세 grid (설비별 시간)
  public getUsageloadGrid (param : UsageLoadSearchModel) {
    const url = process.env.REACT_APP_URL_CO + "/pc/eu/usageload/minute";
    return super.get<UsageLoadLatest[]>(url, param);
  }

  // 태양광 유지보수 업체 - 태양광 발전 자원
  public getPvMaintTgBiz() {
    const url = process.env.REACT_APP_URL_CO + "/pvmaint/rsrc/biz";
    return super.get<PvMaintPvStatModel[]>(url);
  }

  // 태양광 유지보수 업체 - 태양광 발전 현황 요약
  public getPvMaintPvStatSummary(param: CoSearchModel) {
    const url = process.env.REACT_APP_URL_CO + "/pvmaint/stat/summary";
    return super.get<PvMaintPvStatSummaryModel>(url, param);
  }

  // 태양광 유지보수 업체 - 태양광 발전 현황
  public getPvMaintPvStat(param: CoSearchModel) {
    const url = process.env.REACT_APP_URL_CO + "/pvmaint/stat/data";
    return super.get<PvMaintPvStatModel[]>(url, param);
  }

  // 태양광 유지보수 업체 - 태양광 발전 효율
  public getPvMaintPvEfficiency(param: CoSearchModel) {
    const url = process.env.REACT_APP_URL_CO + "/pvmaint/eff/data";
    return super.get<PvMaintPvEffModel[]>(url, param);
  }

  // 태양광 유지보수 업체 - 태양광 발전 일일보고 - 헤더
  public getPvReportSummaryData(param: CoSearchModel) {
    const url = process.env.REACT_APP_URL_CO + "/pvmaint/rpt/data/summary";
    return super.get<PvMainReportDataModel>(url, param);
  }

  // 태양광 유지보수 업체 - 태양광 발전 일일보고 - 헤더
  public getPvReportChartData(param: CoSearchModel) {
    const url = process.env.REACT_APP_URL_CO + "/pvmaint/rpt/data/chart";
    return super.get<PvMainReportDataModel>(url, param);
  }

  // 태양광 유지보수 업체 - 태양광 발전 일일보고 - 헤더
  public getPvReportAlarmData(param: CoSearchModel) {
    const url = process.env.REACT_APP_URL_CO + "/pvmaint/rpt/data/alarm";
    return super.get<PvMainReportDataModel[]>(url, param);
  }

  // 태양광 유지보수 업체 - 태양광 발전 일일보고 - 헤더
  public getPvReportAbnormalPrData(param: CoSearchModel) {
    const url = process.env.REACT_APP_URL_CO + "/pvmaint/rpt/data/abnormal-pr";
    return super.get<PvMainReportDataModel[]>(url, param);
  }
}
